"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var PrizesTable_1 = __importDefault(require("./PrizesTable"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var TournamentPrizes = function (_a) {
    var prizes = _a.prizes, userConfirmed = _a.userConfirmed, tournamentId = _a.tournamentId, isFinished = _a.isFinished, hasTitle = _a.hasTitle;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var sortedPrizes = (0, react_1.useMemo)(function () {
        return prizes === null || prizes === void 0 ? void 0 : prizes.sort(function (a, b) { return Number(a === null || a === void 0 ? void 0 : a.position) - Number(b === null || b === void 0 ? void 0 : b.position); });
    }, [prizes]);
    var _b = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _b.joinTournament, isSubmitting = _b.isSubmitting;
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    if (!sortedPrizes || sortedPrizes.length === 0)
        return null;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        hasTitle && react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('tournamentPrizes')),
        react_1.default.createElement(PrizesTable_1.default, { prizes: sortedPrizes }),
        !isFinished && !userConfirmed && (react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer },
            react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", text: "upper", height: "50px", maxWidth: "100%", loading: isSubmitting, onClick: function () { return participate(tournamentId); } }, t('joinNow'))))));
};
exports.default = TournamentPrizes;
